const treatmentRules = {
    title: {
      max: 25,
      min: 5
    },
    image: {
      max: 5e6
    },
    description: {
      max: 250,
      min: 30
    },
    age: {
      max: 130
    },
    history: {
      max: 250
    },
    category: {
      min: 1
    },
    notes: {
      max: 250
    }
  }

  export default treatmentRules;